/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchOperationFailureDto } from './BatchOperationFailureDto';
import {
    BatchOperationFailureDtoFromJSON,
    BatchOperationFailureDtoFromJSONTyped,
    BatchOperationFailureDtoToJSON,
    BatchOperationFailureDtoToJSONTyped,
} from './BatchOperationFailureDto';

/**
 * 
 * @export
 * @interface BatchOperationResponseDto
 */
export interface BatchOperationResponseDto {
    /**
     * Successfully processed request IDs
     * @type {Array<string>}
     * @memberof BatchOperationResponseDto
     */
    success: Array<string>;
    /**
     * Failed operations
     * @type {Array<BatchOperationFailureDto>}
     * @memberof BatchOperationResponseDto
     */
    failed: Array<BatchOperationFailureDto>;
}

/**
 * Check if a given object implements the BatchOperationResponseDto interface.
 */
export function instanceOfBatchOperationResponseDto(value: object): value is BatchOperationResponseDto {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('failed' in value) || value['failed'] === undefined) return false;
    return true;
}

export function BatchOperationResponseDtoFromJSON(json: any): BatchOperationResponseDto {
    return BatchOperationResponseDtoFromJSONTyped(json, false);
}

export function BatchOperationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchOperationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'failed': ((json['failed'] as Array<any>).map(BatchOperationFailureDtoFromJSON)),
    };
}

export function BatchOperationResponseDtoToJSON(json: any): BatchOperationResponseDto {
    return BatchOperationResponseDtoToJSONTyped(json, false);
}

export function BatchOperationResponseDtoToJSONTyped(value?: BatchOperationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'failed': ((value['failed'] as Array<any>).map(BatchOperationFailureDtoToJSON)),
    };
}

